export default __webpack_public_path__ + "static/media/pdf_icon.06d1b876.svg";